import { getState } from '../../../redux/store/configureStore';
import { APPLICANT_STATUS } from '../../../common/enums';

function applicantStatuses() {
  const {
    staticData : {
      applicantStatus : statuses
    }
  } = getState();

  return statuses;
}

export function enableInstructions(statusId = 0) {
  return [
    APPLICANT_STATUS.PENDING_APPLICATION,
    APPLICANT_STATUS.PENDING_ASSESSMENTS,
    APPLICANT_STATUS.PENDING_APPLICATION_INTERVIEW,
    APPLICANT_STATUS.PENDING_INFORMATION_UPDATE,
    APPLICANT_STATUS.IN_WAITING,
    APPLICANT_STATUS.PENDING_REVIEW
  ].includes(statusId);
}

export function enableAssessments(statusId = 0) {
  return [
    APPLICANT_STATUS.PENDING_ASSESSMENTS,
    APPLICANT_STATUS.PENDING_APPLICATION_INTERVIEW,
    APPLICANT_STATUS.PENDING_INFORMATION_UPDATE,
    APPLICANT_STATUS.PENDING_REVIEW
  ].includes(statusId);
}

export function enableTechnologySurvey(statusId = 0) {
  return [
    APPLICANT_STATUS.READY_TO_PLACE,
    APPLICANT_STATUS.PENDING_TECH_EVALUATION,
    APPLICANT_STATUS.PENDING_REFERENCE_CHECKS,
    APPLICANT_STATUS.ACTIVE,
    APPLICANT_STATUS.PLACED
  ].includes(statusId);
}

export function isQualified(statusId = 0) {
  return [
    APPLICANT_STATUS.QUALIFIED_CANDIDATE,
    APPLICANT_STATUS.READY_TO_PLACE,
    APPLICANT_STATUS.PENDING_REFERENCE_CHECKS,
    APPLICANT_STATUS.QUALIFIED_IN_WAITING,
    APPLICANT_STATUS.QUALIFIED_CANDIDATE_IN_QUEUE,
    APPLICANT_STATUS.ACTIVE,
    APPLICANT_STATUS.PLACED,
    APPLICANT_STATUS.PENDING_TECH_EVALUATION
 ].includes(statusId);
}

export function hasInterviewed(statusId = 0) {
  return !([
    APPLICANT_STATUS.NEW_APPLICANT,
    APPLICANT_STATUS.PENDING_PRELIMINARY_INTERVIEW,
    APPLICANT_STATUS.NOT_QUALIFIED,
    APPLICANT_STATUS.NOT_INTERESTED,
  ].includes(statusId));
}

export function hasSubmitted(applicantProfile = {}) {
  return !!(applicantProfile && applicantProfile.dateAuthorized);
}

// Determine if Applicant status indicates that they're in the Inactive Pipeline

export function isInactivePipeline(statusId = 0) {
  // if applicant status is in list of status' where subGroup === 'Inactive' return true
  // eslint-disable-next-line yoda
  return true === applicantStatuses()
    .filter(status => status.subGroup === 'Inactive')
    .map(status => status.id)
    .includes(statusId);
}



// WEBPACK FOOTER //
// ./shared/react/applicant/helpers/status.js